function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

/**
 * Does nothing
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noOp() {}
/**
 * Get union of two sets.
 * @param setA
 * @param setB
 * @returns union of two sets
 */

function union(setA, setB) {
  return new Set([].concat(toConsumableArray(setA), toConsumableArray(setB)));
}
/**
 * Get intersection of two sets.
 * @param setA
 * @param setB
 * @returns intersection of two sets
 */

function intersection(setA, setB) {
  return new Set(toConsumableArray(setA).filter(function (x) {
    return setB.has(x);
  }));
}
/**
 * Get difference of two sets.
 * @param setA
 * @param setB
 * @returns difference between two sets
 */

function difference(setA, setB) {
  return new Set(toConsumableArray(setA).filter(function (x) {
    return !setB.has(x);
  }));
}
/**
 * Identifies if value is NaN.
 * @param val
 */

function isNaN(val) {
  if (typeof val === 'number') {
    return Number.isNaN(val);
  }

  return false;
}
/**
 * Identifies if value is not defined.
 * undefined, null and NaN are not considered as defined.
 * @param val
 */

function isNotDefined(val) {
  return val === undefined || val === null || isNaN(val);
}
/**
 * Identifies if value is defined.
 * @param val
 */

function isDefined(val) {
  return !isNotDefined(val);
}
/**
 * Identifies if value is falsy.
 * undefined, null, NaN and false are considered as false value.
 * @param val
 * @param override list of additional values that are considered false values
 */

function isFalsy(val) {
  var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return isNotDefined(val) || val === false || override.includes(val);
}
/**
 * Identifies if value is truthy.
 * @param val
 * @param override list of additional values that are considered true values
 */

function isTruthy(val) {
  var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return !isFalsy(val) || override.includes(val);
}
/**
 * Identifies if value is falsy string.
 * undefined, null, NaN, false, '' are considered as false value.
 * @param val
 */

function isFalsyString(val) {
  return isFalsy(val, ['']);
}
/**
 * Identifies if value is truthy string.
 * @param val
 */

function isTruthyString(val) {
  return !isFalsyString(val);
}
/**
 * Resolves if first argument is function with other arguments as argument to
 * user supplied function.
 * @param variable either a function to resolive or any value
 * @param args arguments for user supplied function
 * @returns value resolved from user supplied function
 */

function resolve(variable) {
  if (typeof variable === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return variable.apply(void 0, args);
  }

  return variable;
}

/**
 * Convert hex to yiq colorspace and get the luma value
 * @param color
 * @returns yiq luma value
 */
// https://en.wikipedia.org/wiki/YIQ#From_RGB_to_YIQ
function getContrastYIQ(color) {
  var r = parseInt(color.substr(1, 2), 16);
  var g = parseInt(color.substr(3, 2), 16);
  var b = parseInt(color.substr(5, 2), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / (255 * 1000);
  return yiq;
}
/**
 * Identifies if given color is valid color.
 * @param color
 */

function isValidHexColor(color) {
  var colorHex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;
  return colorHex.test(color);
}
/**
 * Get appropriate foreground color for a given background color.
 * @param color color for background
 * @param colorOnLight color for light background
 * @param colorOnDark color for dark background
 * @returns appropriate foreground color
 */

function getColorOnBgColor(color) {
  var colorOnLight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#212121';
  var colorOnDark = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#ffffff';
  return getContrastYIQ(color) > 0.5 ? colorOnLight : colorOnDark;
}
/**
 * Get hash from a string.
 * @param str any string
 * @returns hash derived from string
 */

function getHashFromString(str) {
  var hash = 0;

  for (var i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash); // eslint-disable-line
  }

  return hash;
}
/**
 * Get color from a number.
 * @param code
 * @returns color derived from hash
 */

function getHexFromCode(code) {
  var color = (code & 0x00FFFFFF). // eslint-disable-line
  toString(16).toUpperCase(); // FIXME: use padStart

  var hex = '00000'.substring(0, 6 - color.length) + color;
  return "#".concat(hex);
}
/**
 * Get color from string.
 * @param str any string
 */

function getHexFromString(str) {
  return getHexFromCode(getHashFromString(str));
}
/**
 * Get hex color from rgb color.
 * @param color
 */

function getHexFromRgbRaw(color) {
  var _color = slicedToArray(color, 3),
      r = _color[0],
      g = _color[1],
      b = _color[2]; // eslint-disable-next-line no-bitwise


  return "#".concat(((r << 16) + (g << 8) + b).toString(16).padStart(6, '0'));
}
/**
 * Get hex color from rgb color.
 * @param color
 */

function getHexFromRgb(color) {
  var result = /^rgb\((\d+),\s*(\d+),\s*(\d+)/i.exec(color);

  if (!result) {
    return undefined;
  }

  var r = parseInt(result[1], 10);
  var g = parseInt(result[2], 10);
  var b = parseInt(result[3], 10);
  return getHexFromRgbRaw([r, g, b]);
}
/**
 * Get rgb color from hex color.
 * @param color
 */

function getRgbRawFromHex(color) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);

  if (!result) {
    return undefined;
  }

  return [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)];
}
/**
 * Get rgb color from hex color 'rgb(255, 255, 255)'.
 * @param hex hex color '#ffffff'
 */

function getRgbFromHex(hex) {
  var color = getRgbRawFromHex(hex);

  if (isNotDefined(color)) {
    return undefined;
  }

  var _color2 = slicedToArray(color, 3),
      r = _color2[0],
      g = _color2[1],
      b = _color2[2];

  return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}
/**
 * Interpolate two rgb colors.
 * @param color1
 * @param color2
 * @param factor decides where the interpolated color lies.
 * @returns interpolated rgb color
 */
// Taken from the awesome ROT.js roguelike dev library at
// https://github.com/ondras/rot.js

function interpolateRgb(color1, color2) {
  var factor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
  var result = [Math.round(factor * (color2[0] - color1[0]) + color1[0]), Math.round(factor * (color2[1] - color1[1]) + color1[1]), Math.round(factor * (color2[2] - color1[2]) + color1[2])];
  return result;
}

var comparison = function comparison(extractor, comparisonFunc) {
  return function (x, y) {
    var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var a = isDefined(x) ? extractor(x) : undefined;
    var b = isDefined(y) ? extractor(y) : undefined;

    if (a === b) {
      return 0;
    }

    if (isNotDefined(a)) {
      return direction * 1;
    }

    if (isNotDefined(b)) {
      return direction * -1;
    }

    return direction * comparisonFunc(a, b);
  };
}; // NOTE: func is never called for boolean


var compareBoolean = comparison(function (x) {
  return x;
}, function (a, b) {
  return Number(a) - Number(b);
});
var compareString = comparison(function (x) {
  return x;
}, function (a, b) {
  return a.localeCompare(b);
});
var compareNumber = comparison(function (x) {
  return x;
}, function (a, b) {
  return a - b;
});
var compareDate = comparison(function (x) {
  return x;
}, function (a, b) {
  var dateA = new Date(a);
  var dateB = new Date(b);
  return dateA.getTime() - dateB.getTime();
});
var compareStringAsNumber = comparison(function (x) {
  return Number(x);
}, function (a, b) {
  return a - b;
});
var compareLength = comparison(function (x) {
  return x.length;
}, function (a, b) {
  return a - b;
});
var compareStringByWordCount = comparison(function (x) {
  return x.split(/\s+/).length;
}, function (a, b) {
  return a - b;
});
var compareStringSearch = function compareStringSearch(x, y, z, d) {
  if (!z) {
    return 0;
  }

  return comparison(function (a) {
    return a;
  }, function (a, b) {
    var searchText = z.toLowerCase();
    var firstIndex = a.toLowerCase().indexOf(searchText);
    var secondIndex = b.toLowerCase().indexOf(searchText);

    if (firstIndex === secondIndex) {
      return a.localeCompare(b);
    }

    if (firstIndex === -1 && secondIndex === -1) {
      return a.localeCompare(b);
    }

    if (secondIndex === -1) {
      return -1;
    }

    if (firstIndex === -1) {
      return 1;
    }

    return firstIndex - secondIndex;
  })(x, y, d);
};

/**
 * Concatenate valid string into classname
 * @param props arguments to concatenate
 * @returns final classname
 */
// eslint-disable-next-line import/prefer-default-export, no-underscore-dangle

function _cs() {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }

  return props.filter(isTruthyString).join(' ');
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

/**
 * Add padding before string or number
 *
 * @param value
 * @param length total length of the output
 * @param pad character used to pad
 *
 * @remarks
 * Use when String(num).padStart(length, str) not fully supported
 */

function padStart(value, length) {
  var pad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';

  if (isNotDefined(value)) {
    return '';
  }

  var str = String(value);
  return str.length >= length ? str : Array(length - str.length + 1).join(pad) + str;
}
/**
 * Change the first letter of word to uppercase
 *
 * @param str
 */

function capitalize(str) {
  if (isTruthyString(str)) {
    return str.replace(/\b\w/g, function (l) {
      return l.toUpperCase();
    });
  }

  return str;
}
/**
 * Format text, extracted from pdfs, to remove extraneous spaces
 *
 * @param text
 */

function formatPdfText(text) {
  return text // Tab to space
  .replace(/\t/gi, ' ') // Anything except ascii TODO: support accents and other utf-8
  // text = text.replace(/[^\x00-\x7F]/g, "");
  // Single line break to space
  .replace(/([^\n])[ \t]*\n[ \t]*(?!\n)/gi, '$1 ') // Multiple spaces to single
  .replace(/ +/gi, ' ') // More than 3 line breaks to just 3 line breaks
  .replace(/\n\s*\n\s*(\n\s*)+/gi, '\n\n\n') // This weird -? text combo to just -
  .replace(/-\?/gi, '-').trim();
}
/**
 * Get rating for content in string
 *
 * @param content
 * @param str
 */

function getRatingForContentInString(content, str) {
  // FIXME: the behavior needs to be tested again
  if (isFalsyString(content) || isFalsyString(str)) {
    return -1;
  }

  return content.toLowerCase().indexOf(str.toLowerCase());
}
/**
 * Get random string
 *
 * @param length length of the random string
 * @param mixedCase if uppercase alphabets are to be included
 */

function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
  var mixedCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var text = '';
  var possible = mixedCase ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789' : 'abcdefghijklmnopqrstuvwxyz0123456789';

  for (var i = 0; i < length; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
  /*
   * -------------------------------------------------
   * better Algorithm, but not supported by enzyme :(
   * -------------------------------------------------
   const randomValues = new Uint8Array(length);
  window.crypto.getRandomValues(randomValues);
  return Array.from(randomValues, v => v.toString(36)).join('').substring(0, 8);
  */
}
/**
 * Convert camel case to space separated words
 *
 * @param str
 * @param separator
 *
 * @remarks
 * Only support alphabets (not numerals)
 */

var reOne = /([a-z])([A-Z])([A-Z])/g;
var reTwo = /([a-z])([A-Z])/g;
var reThree = /([A-Z])([A-Z])([a-z])/g;
function camelToNormal(str) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

  if (isNotDefined(str)) {
    return str;
  }

  return str.replace(reOne, function (_, one, two, three) {
    return "".concat(one).concat(separator).concat(two).concat(three);
  }).replace(reTwo, function (_, one, two) {
    return "".concat(one).concat(separator).concat(two.toLowerCase());
  }).replace(reThree, function (_, one, two, three) {
    return "".concat(one).concat(separator).concat(two.toLowerCase()).concat(three);
  });
}
/**
 * Convert camel case to snake case
 *
 * @param str
 *
 * @remarks
 * Only support alphabets (not numerals)
 */

function camelToSnake(str) {
  if (isNotDefined(str)) {
    return str;
  }

  var value = camelToNormal(str, '_');
  return value.charAt(0).toLowerCase() + value.slice(1);
}
/**
 * Convert camel case to kebab case
 *
 * @param str
 *
 * @remarks
 * Only support alphabets (not numerals)
 */

function camelToKebab(str) {
  if (isNotDefined(str)) {
    return str;
  }

  var value = camelToNormal(str, '-');
  return value.charAt(0).toLowerCase() + value.slice(1);
}
/**
 * Split sentence
 *
 * @param str
 */

function splitInWhitespace(str) {
  if (isNotDefined(str)) {
    return [];
  }

  return str.match(/\S+/g) || [];
}
/**
 * Convert all whitespaces into single space
 *
 * @param str
 */

function trimWhitespace(str) {
  if (isNotDefined(str)) {
    return str;
  }

  return splitInWhitespace(str).join(' ');
}
/**
 * Identify if shortText is inside longText
 *
 * @param longText
 * @param shortText
 *
 * @remarks
 * The match is case-insensitive
 *
 */

function caseInsensitiveSubmatch(longText, shortText) {
  if (isNotDefined(longText) || isNotDefined(shortText)) {
    return false;
  }

  return String(longText).trim().toLowerCase().includes(String(shortText).trim().toLowerCase());
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var ValueType;

(function (ValueType) {
  ValueType["time"] = "time";
  ValueType["date"] = "date";
})(ValueType || (ValueType = {}));

function getStartAndEnd(format, matches) {
  var minStart;
  var maxEnd;
  matches.forEach(function (val) {
    var start = format.indexOf(val);

    if (start === -1) {
      return;
    }

    var end = start + val.length;

    if (minStart === undefined || start < minStart) {
      minStart = start;
    }

    if (maxEnd === undefined || end > maxEnd) {
      maxEnd = end;
    }
  });
  return {
    start: minStart,
    end: maxEnd
  };
}
/**
 * Break timedate format into time unit, date unit and other unit.
 *
 * @remarks
 * The date unit are: yyyy, yy, MMM, MM, dd, EEE.
 * The time unit are: hh, mm, ss, aaa.
 * Anything can come in between date and time unit and they will be treated as separator.
 * @param format format for datetime
 */


function breakFormat(format) {
  var _getStartAndEnd = getStartAndEnd(format, ['yyyy', 'yy', 'MMM', 'MM', 'dd', 'EEE']),
      dateStart = _getStartAndEnd.start,
      dateEnd = _getStartAndEnd.end;

  var _getStartAndEnd2 = getStartAndEnd(format, ['hh', 'mm', 'ss', 'aaa']),
      timeStart = _getStartAndEnd2.start,
      timeEnd = _getStartAndEnd2.end;

  var formatEnd = format.length;

  var getSubFormat = function getSubFormat(start, end) {
    if (start === undefined || end === undefined) {
      return '';
    }

    return format.substring(start, end);
  };

  if (dateStart === undefined && timeStart === undefined) {
    return [{
      value: format
    }].filter(function (a) {
      return a.value !== '';
    });
  }

  if (dateStart === undefined) {
    return [{
      value: getSubFormat(0, timeStart)
    }, {
      type: ValueType.time,
      value: getSubFormat(timeStart, timeEnd)
    }, {
      value: getSubFormat(timeEnd, formatEnd)
    }].filter(function (a) {
      return a.value !== '';
    });
  }

  if (timeStart === undefined) {
    return [{
      value: getSubFormat(0, dateStart)
    }, {
      type: ValueType.date,
      value: getSubFormat(dateStart, dateEnd)
    }, {
      value: getSubFormat(dateEnd, formatEnd)
    }].filter(function (a) {
      return a.value !== '';
    });
  }

  if (dateStart < timeStart) {
    return [{
      value: getSubFormat(0, dateStart)
    }, {
      type: ValueType.date,
      value: getSubFormat(dateStart, dateEnd)
    }, {
      value: getSubFormat(dateEnd, timeStart)
    }, {
      type: ValueType.time,
      value: getSubFormat(timeStart, timeEnd)
    }, {
      value: getSubFormat(timeEnd, formatEnd)
    }].filter(function (a) {
      return a.value !== '';
    });
  }

  return [{
    value: getSubFormat(0, timeStart)
  }, {
    type: ValueType.time,
    value: getSubFormat(timeStart, timeEnd)
  }, {
    value: getSubFormat(timeEnd, dateStart)
  }, {
    type: ValueType.date,
    value: getSubFormat(dateStart, dateEnd)
  }, {
    value: getSubFormat(dateEnd, formatEnd)
  }].filter(function (a) {
    return a.value !== '';
  });
}
/**
 * Populate the format list with date
 *
 * @param formatList the list of datetime units
 * @param date
 */

function populateFormat(formatList, date) {
  return formatList.map(function (format) {
    if (format.type === ValueType.date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var weekName = DAYS[date.getDay()];

      var newFormat = _objectSpread({}, format);

      newFormat.value = newFormat.value.replace('yyyy', String(year)).replace('yy', String(date.getFullYear() % 100)).replace('MMM', MONTHS[date.getMonth()]).replace('MM', padStart(month, 2)).replace('EEE', weekName).replace('dd', padStart(day, 2));
      return newFormat;
    }

    if (format.type === ValueType.time) {
      var ttIndex = format.value.indexOf('aaa');
      var originalHour = date.getHours();
      var hour = ttIndex >= 0 ? (originalHour - 1) % 12 + 1 : originalHour;
      var amPm = originalHour >= 12 ? 'PM' : 'AM';
      var minute = date.getMinutes();
      var second = date.getSeconds();

      var _newFormat = _objectSpread({}, format);

      _newFormat.value = _newFormat.value.replace('hh', padStart(hour, 2)).replace('mm', padStart(minute, 2)).replace('ss', padStart(second, 2)).replace('aaa', amPm);
      return _newFormat;
    }

    return format;
  });
}
/**
 * Format date
 *
 * @param date
 * @param format format for datetime
 * @returns formatted date
 */

function formatDateToString(date, format) {
  return populateFormat(breakFormat(format), date).map(function (e) {
    return e.value;
  }).join('');
}
/**
 * Set hour, minute and second to zero in given datetime
 *
 * @param date timestamp or a date string
 * @returns timestamp with hour, minute and second set to zero
 */

function getDate(datetime) {
  var today = new Date(datetime);
  today.setHours(0, 0, 0, 0);
  return today.getTime();
}
/**
 * Get number of days betwen two datetime
 *
 * @param a timestamp or a date string
 * @param b timestamp or a date string
 * @returns number of days between two datetime
 */

function getDifferenceInDays(a, b) {
  var dateA = getDate(a);
  var dateB = getDate(b);
  return (dateA - dateB) / (1000 * 60 * 60 * 24);
}
/**
 * Get number of days betwen two datetime
 *
 * @param a timestamp or a date string
 * @param b timestamp or a date string
 * @returns number of days between two datetime
 */

function getDateDifferenceHumanReadable(a, b) {
  var diff = getDifferenceInDays(a, b);

  if (diff === 0) {
    return 'Today';
  }

  if (diff === -1) {
    return 'Yesterday';
  }

  if (diff === 1) {
    return 'Tomorrow';
  }

  if (diff < 0) {
    return "".concat(-diff, " days ago");
  }

  return "After ".concat(diff, " days");
}
/**
 * Get number of days in certain year and month
 *
 * @param year
 * @param month
 * @returns number of days
 *
 * @remarks
 * Month starts from 1 (not zero)
 */

function getNumDaysInMonthX(year, month) {
  if (isTruthy(year) && isTruthy(month)) {
    return new Date(year, month, 0).getDate();
  }

  return 32;
}
/**
 * Get number of days in certain year and month from a date
 *
 * @param date
 * @returns number of days
 */

function getNumDaysInMonth(date) {
  if (date) {
    return getNumDaysInMonthX(date.getFullYear(), date.getMonth() + 1);
  }

  return 32;
}
/**
 * Change date into 'yyyy-MM-dd' string
 *
 * @param date
 */

function encodeDate(date) {
  return formatDateToString(date, 'yyyy-MM-dd');
}
/**
 * Change timestamp or 'yyyy-MM-dd' string into date
 *
 * @param value timestamp or 'yyyy-MM-dd' string
 */

function decodeDate(value) {
  // Let's assume that the value is in local time zone
  if (!value) {
    return undefined;
  } // Check if value is timestamp number or ISO string with time information
  // In both case, new Date assumes local time zone


  if (typeof value === 'number' || value.indexOf('T') >= 0) {
    return new Date(value);
  } // In case of ISO string with no time information, new Date assumes
  // UTC timezone. So first split it manually, and feed them separately
  // so they will be processed as local time zone.


  var splits = value.split('-');
  return new Date(Number(splits[0]), Number(splits[1]) - 1, Number(splits[2]));
}
var MIN_YEAR = 1990;

/**
 * Identify if ymd value is complete
 *
 * @param ymd
 */
function isDateValuesComplete(ymd) {
  var yearValue = ymd.yearValue,
      monthValue = ymd.monthValue,
      dayValue = ymd.dayValue; // Complete if all values are undefined or none are

  return isTruthy(dayValue) && isTruthy(monthValue) && isTruthy(yearValue) || isFalsy(dayValue) && isFalsy(monthValue) && isFalsy(yearValue);
}
/**
 * Identify problem with ymd value
 *
 * @param ymd
 *
 * @remarks
 * The return value will be undefined if there are no problems.
 */

function getErrorForDateValues(ymd) {
  if (!isDateValuesComplete(ymd)) {
    return 'Date values incomplete';
  }

  var yearValue = ymd.yearValue,
      monthValue = ymd.monthValue,
      dayValue = ymd.dayValue;

  if (yearValue < MIN_YEAR) {
    return "Year should be greater than or equal to ".concat(MIN_YEAR);
  }

  if (monthValue < 1 || monthValue > 12) {
    return 'Month should be between 1 and 12';
  }

  var maxNumberOfDays = getNumDaysInMonthX(yearValue, monthValue);

  if (dayValue < 1 || dayValue > maxNumberOfDays) {
    return 'Invalid day for this month';
  }

  return undefined;
}
var MIN_HOUR = 0;
var MAX_HOUR = 23;
var MIN_MINUTE = 0;
var MAX_MINUTE = 59;
var MIN_SECOND = 0;
var MAX_SECOND = 59;

/**
 * Identify if hms value is complete
 *
 * @param hms
 */
var isTimeValuesComplete = function isTimeValuesComplete(val) {
  var hourValue = val.hourValue,
      minuteValue = val.minuteValue,
      secondValue = val.secondValue; // Complete if all values are undefined or none are

  return isTruthy(hourValue) && isTruthy(minuteValue) && isTruthy(secondValue) || isFalsy(hourValue) && isFalsy(minuteValue) && isFalsy(secondValue);
};
/**
 * Identify problem with hms value
 *
 * @param hms
 *
 * @remarks
 * The return value will be undefined if there are no problems.
 */

var getErrorForTimeValues = function getErrorForTimeValues(val) {
  if (!isTimeValuesComplete(val)) {
    return 'Time values incomplete';
  }

  var hourValue = val.hourValue,
      minuteValue = val.minuteValue,
      secondValue = val.secondValue;

  if (hourValue < MIN_HOUR || hourValue > MAX_HOUR) {
    return "Hour must be between ".concat(MIN_HOUR, " and ").concat(MAX_HOUR);
  }

  if (minuteValue < MIN_MINUTE || minuteValue > MAX_MINUTE) {
    return "Minute must be between ".concat(MIN_MINUTE, " and ").concat(MAX_MINUTE);
  }

  if (secondValue < MIN_SECOND || secondValue > MAX_SECOND) {
    return "Second must be between ".concat(MIN_SECOND, " and ").concat(MAX_SECOND);
  }

  return undefined;
};

/**
 * Get nth node from a linked list.
 * @param node the first node of the linked list
 * @param n the nth node after the first node
 * @param selector get next node from current node
 *
 * @returns the nth node
 */
// eslint-disable-next-line import/prefer-default-export
function getLinkedListNode(node, n, selector) {
  var newNode = node;

  for (var i = 0; i < n; i += 1) {
    newNode = selector(newNode, i);

    if (isNotDefined(newNode)) {
      break;
    }
  }

  return newNode;
}

function listToMap(list, keySelector, modifier) {
  if (isNotDefined(list)) {
    return undefined;
  }

  var value = list.reduce(function (acc, elem, i) {
    var key = keySelector(elem);
    acc[String(key)] = modifier ? modifier(elem, key, i, acc) : elem;
    return acc;
  }, {});
  return value;
}
/**
 * Transform object to list
 * @param obj
 * @param modifier get new value from item in object
 */

function mapToList(obj, modifier) {
  if (isNotDefined(obj)) {
    return undefined;
  }

  return Object.keys(obj).reduce(function (acc, key, i) {
    var elem = obj[key];
    acc.push(modifier ? modifier(elem, key, i, acc) : elem);
    return acc;
  }, []);
}
/**
 * Transform object to object
 * @param obj
 * @param keySelector get new key for item in object
 * @param modifier get new value for item in object
 */

function mapToMap(obj, keySelector, modifier) {
  if (isNotDefined(obj)) {
    return undefined;
  }

  var value = Object.keys(obj).reduce(function (acc, k, i) {
    var elem = obj[k];
    var key = keySelector ? keySelector(k, elem) : k;
    acc[String(key)] = modifier ? modifier(elem, k, i, acc) : elem;
    return acc;
  }, {});
  return value;
}
/**
 * Group list into object of list.
 * Items in list are grouped by key returned by keySelector
 * @param list
 * @param keySelector get key for item in list
 * @param modifier get new value for item in list
 */

function listToGroupList(list, keySelector, modifier) {
  if (isNotDefined(list)) {
    return undefined;
  }

  var val = list.reduce(function (acc, elem, i) {
    var key = keySelector(elem);
    var value = modifier ? modifier(elem, key, i, acc) : elem;

    if (acc[String(key)]) {
      acc[String(key)].push(value);
    } else {
      acc[String(key)] = [value];
    }

    return acc;
  }, {});
  return val;
}

/**
 * Identify if two list are the same
 *
 * @param list1
 * @param list2
 *
 * @remarks
 * The function assumes that the elements aren't mutated
 */

function isListEqual(list1, list2) {
  return list1.length === list2.length && list1.every(function (d, i) {
    return d === list2[i];
  });
}
/**
 * Get a random item from the list
 *
 * @param items
 */

function getRandomFromList(items) {
  return items[Math.floor(Math.random() * items.length)];
}
/**
 * Get an element around certain index in a list
 *
 * @param list
 * @param index
 */

function getElementAround(list, index) {
  if (index + 1 < list.length) {
    return list[index + 1];
  }

  if (index - 1 >= 0) {
    return list[index - 1];
  }

  return undefined;
}
/**
 * Get a defined element around certain index in a list
 *
 * @param list
 * @param index
 */

function getDefinedElementAround(list, currentIndex) {
  var i;
  var j;

  for (i = currentIndex - 1; i >= 0; i -= 1) {
    if (list[i] !== undefined) {
      break;
    }
  }

  for (j = currentIndex + 1; j < list.length; j += 1) {
    if (list[j] !== undefined) {
      break;
    }
  }

  if (i < 0 && j >= list.length) {
    // console.warn('none');
    return undefined;
  }

  if (i < 0 && j < list.length) {
    // console.warn('none on left');
    return list[j];
  }

  if (j >= list.length && i >= 0) {
    // console.warn('none on right');
    return list[i];
  }

  var iDist = currentIndex - i;
  var jDist = j - currentIndex;

  if (jDist > iDist) {
    return list[i];
  }

  return list[j];
}
/**
 * Get a duplicate count for each element in a list
 *
 * @param list
 * @param keySelector get key from an element
 *
 * @returns map of element key and duplicate count
 *
 * @remarks
 * The map only includes element for which there is a duplicate
 */

function getDuplicates(list, keySelector) {
  if (!list) {
    return undefined;
  }

  var counts = listToMap(list, keySelector, function (_, key, __, acc) {
    return isDefined(acc[String(key)]) ? acc[String(key)] + 1 : 1;
  });
  return Object.keys(counts).filter(function (key) {
    return counts[key] > 1;
  });
}
/**
 * Find difference between two list
 *
 * @param listA
 * @param listB
 * @param keySelector get key from an element
 *
 * @returns list of added, modified, removed and unmodified elements
 */

function findDifferenceInList(listA, listB, keySelector) {
  var modified = [];
  var added = [];
  var removed = [];
  var unmodified = [];
  var mapA = listToMap(listA, keySelector, function (e) {
    return e;
  });
  listB.forEach(function (elem) {
    var key = keySelector(elem);

    if (isNotDefined(mapA[String(key)])) {
      added.push(elem);
    } else if (mapA[String(key)] !== elem) {
      modified.push({
        old: mapA[String(key)],
        new: elem
      });
    } else {
      unmodified.push(elem);
    }
  });
  var mapB = listToMap(listB, keySelector, function (e) {
    return e;
  });
  listA.forEach(function (elem) {
    var key = keySelector(elem);

    if (isNotDefined(mapB[String(key)])) {
      removed.push(elem);
    }
  });
  return {
    added: added,
    modified: modified,
    removed: removed,
    unmodified: unmodified
  };
}
/**
 * Find unique items from a list
 *
 * @param list
 * @param getItemHash method to get id to check uniqueness
 *
 * @remarks
 * If getItemHash is not supplied, comparision is done by casting items in list
 * to string
 */

function unique(list, getItemHash) {
  if (isNotDefined(list)) {
    return undefined;
  }

  var memory = {};
  var arrWithUnique = [];
  list.forEach(function (item) {
    var hash = getItemHash ? getItemHash(item) : JSON.stringify(item);

    if (!memory[hash]) {
      memory[hash] = true;
      arrWithUnique.push(item);
    }
  }); // NOTE: just return original array if all elements were unique

  if (list.length === arrWithUnique.length) {
    return list;
  }

  return arrWithUnique;
}

/**
 * Check if new object should be set
 * and should the message of overriden shown
 *
 * @param oldVersionId
 * @param newVersionId
 */
// eslint-disable-next-line import/prefer-default-export

function checkVersion(oldVersionId, newVersionId) {
  return {
    shouldSetValue: isFalsy(oldVersionId) || oldVersionId < newVersionId,
    isValueOverriden: isTruthy(oldVersionId) && oldVersionId < newVersionId
  };
}

var _mappings;
function addSeparator(num) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var decimalSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';

  if (isNotDefined(num)) {
    return num;
  }

  var _String$split = String(num).split(decimalSeparator),
      _String$split2 = slicedToArray(_String$split, 2),
      before = _String$split2[0],
      after = _String$split2[1];

  var x1 = before;
  var rgx = /(\d+)(\d{3})/;

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1".concat(separator, "$2"));
  }

  var x2 = after !== undefined ? "".concat(decimalSeparator).concat(after) : '';
  return x1 + x2;
}
var Lang;

(function (Lang) {
  Lang["en"] = "en";
  Lang["np"] = "ne";
})(Lang || (Lang = {}));

var nepaliMapping = [{
  suffix: 'Ar',
  value: 1000000000
}, {
  suffix: 'Cr',
  value: 10000000
}, {
  suffix: 'Lac',
  value: 100000
}];
var englishMapping = [{
  suffix: 'B',
  value: 1000000000
}, {
  suffix: 'M',
  value: 1000000
}, {
  suffix: 'K',
  value: 1000
}];
var mappings = (_mappings = {}, defineProperty(_mappings, Lang.np, nepaliMapping), defineProperty(_mappings, Lang.en, englishMapping), _mappings);
/**
 * Get normalized number
 * @param num
 * @param lang language
 */

function formattedNormalize(num) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Lang.np;
  var mapping = mappings[lang];

  if (isNotDefined(mapping)) {
    console.error("Mapping not defined for ".concat(lang));
    return {
      number: num
    };
  }

  var rule = mapping.find(function (n) {
    return num >= n.value;
  });

  if (isNotDefined(rule)) {
    return {
      number: num
    };
  }

  var suffix = rule.suffix,
      value = rule.value;
  return {
    number: num / value,
    normalizeSuffix: suffix
  };
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Identifies if item is a list.
 * @param item anything
 */
function isList(item) {
  return Array.isArray(item);
}
/**
 * Identifies if item is an object.
 * `null` and `list` are not considered as object.
 * @param item anything
 */

function isObject(item) {
  return item !== null && _typeof_1(item) === 'object' && !isList(item);
}
/**
 * Identifies if item is an integer.
 * Float values are not not considered as integer.
 * @param item anything
 */

function isInteger(value) {
  return typeof value === 'number' && value % 1 === 0;
}
var basicTypes = ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Object', 'Error', 'Symbol']; // Mapping to hold javascript class to custom type

var classToType = basicTypes.reduce(function (acc, type) {
  return _objectSpread$1({}, acc, defineProperty({}, "[object ".concat(type, "]"), type.toLowerCase()));
}, {});
/**
 * Get type of an item.
 * Valid types: null, boolean, number, string, function, array, date, regexp, object, error, symbol
 * @param item anything
 * @returns type of that item
 */

var typeOf = function typeOf(item) {
  if (item == null) {
    return 'null';
  }

  var simpleType = _typeof_1(item);

  return simpleType === 'object' || simpleType === 'function' ? classToType[classToType.toString.call(item)] || 'object' : simpleType;
};
/**
 * Identifies if string is a valid email.
 * @param item any string
 */

function isValidEmail(value) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(value);
}
/**
 * Identifies if string is a valid url.
 * @param item any string
 */

function isValidUrl(value) {
  //
  // Regular Expression for URL validation
  //
  // Author: Diego Perini
  // Updated: 2010/12/05
  // License: MIT
  //
  // Copyright (c) 2010-2013 Diego Perini (http://www.iport.it)
  //
  // Permission is hereby granted, free of charge, to any person
  // obtaining a copy of this software and associated documentation
  // files (the "Software"), to deal in the Software without
  // restriction, including without limitation the rights to use,
  // copy, modify, merge, publish, distribute, sublicense, and/or sell
  // copies of the Software, and to permit persons to whom the
  // Software is furnished to do so, subject to the following
  // conditions:
  //
  // The above copyright notice and this permission notice shall be
  // included in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  // EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
  // OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  // NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
  // HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
  // WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
  // FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
  // OTHER DEALINGS IN THE SOFTWARE.
  //
  // the regular expression composed & commented
  // could be easily tweaked for RFC compliance,
  // it was expressly modified to fit & satisfy
  // these test for an URL shortener:
  //
  //   http://mathiasbynens.be/demo/url-regex
  //
  // Notes on possible differences from a standard/generic validation:
  //
  // - utf-8 char class take in consideration the full Unicode range
  // - TLDs have been made mandatory so single names like "localhost" fails
  // - protocols have been restricted to ftp, http and https only as requested
  //
  // Changes:
  //
  // - IP address dotted notation validation, range: 1.0.0.0 - 223.255.255.255
  //   first and last IP address of each class is considered invalid
  //   (since they are broadcast/network addresses)
  //
  // - Added exclusion of private, reserved and/or local networks ranges
  //
  // - Made starting path slash optional (http://example.com?foo=bar)
  //
  // - Allow a dot (.) at the end of hostnames (http://example.com.)
  //
  var re = new RegExp('^' // protocol identifier
  + '(?:(?:https?|ftp)://)' // user:pass authentication
  + '(?:\\S+(?::\\S*)?@)?' + '(?:' // IP address exclusion
  // private & local networks
  + '(?!(?:10|127)(?:\\.\\d{1,3}){3})' + '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' + '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' // IP address dotted notation octets
  // excludes loopback network 0.0.0.0
  // excludes reserved space >= 224.0.0.0
  // excludes network & broacast addresses
  // (first & last IP address of each class)
  + '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' + '|' // host name
  + "(?:(?:[_a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" // domain name
  + "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" // TLD identifier
  + "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" // TLD may end with dot
  + '\\.?' + ')' // port number
  + '(?::\\d{2,5})?' // resource path
  + '(?:[/?#]\\S*)?' + '$', 'i');
  return re.test(value);
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Pick only certain keys from an object
 * @param obj
 * @param keys
 */

var pick = function pick(obj, keys) {
  return keys.reduce(function (acc, key) {
    return _objectSpread$2({}, acc, defineProperty({}, key, obj[key]));
  }, {});
};
/**
 * Remove a certain key from an object
 * @param obj
 * @param key
 */

function removeKey(obj, key) {
  if (isNotDefined(obj) || !(key in obj)) {
    return obj;
  }

  var newObj = _objectSpread$2({}, obj);

  delete newObj[key];
  return newObj;
}
/**
 * Get key of the first element in an object
 * @param obj
 * @param value
 */

function getFirstKeyByValue(obj, value) {
  return Object.keys(obj).find(function (key) {
    return obj[key] === value;
  });
}
/**
 * Identify if object has no data
 * @param obj
 * @param invalids list of values that aren't considered as data
 */

function doesObjectHaveNoData(obj) {
  var invalids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // NOTE: null and NaN are truthy values here
  if (obj === undefined) {
    return true;
  }

  if (isList(obj)) {
    if (obj.length <= 0) {
      return true;
    }

    return obj.every(function (e) {
      return doesObjectHaveNoData(e, invalids);
    });
  }

  if (isObject(obj)) {
    if (Object.keys(obj).length <= 0) {
      return true;
    }

    return Object.keys(obj).every(function (key) {
      return doesObjectHaveNoData(obj[key], invalids);
    });
  }

  return invalids.includes(obj);
}

/**
 * Fill parameters in route url
 * @param route route template
 * @param params map of values
 */
function reverseRoute(route, params) {
  var paths = route.split('/');

  for (var i = 0; i < paths.length; i += 1) {
    var path = paths[i];

    if (path && path.length > 0 && path.charAt(0) === ':') {
      path = path.substring(1);
      var param = void 0; // optional parameter

      if (path.slice(-1) === '?') {
        param = params[path.replace('?', '')]; // omit if value not supplied

        if (!param) {
          paths.splice(i, 1);
        } else {
          paths[i] = String(param);
        }
      } else {
        param = params[path];

        if (!param) {
          console.error("Value for param ".concat(path, " not supplied"));
        }

        paths[i] = String(param);
      }
    }
  }

  return paths.join('/');
}
/**
 * Identify if param is required in certain route
 * @param route route template
 * @param param parameter name
 */

function isParamRequired(route, param) {
  var re = new RegExp(":".concat(param, "([^\\?]|$)"));
  return route.search(re) !== -1;
}

/**
 * Get `a` modulo `b`
 *
 * @param a dividend
 * @param b divisor
 * @remarks
 * Return a positive modulo
 */
function modulo(a, b) {
  var value = a % b;

  if (value < 0) {
    return b + value;
  } // NOTE: -0 is not less than 0, so we need to take absolute value


  return Math.abs(value);
}
/**
 * Get sum of all elements in a list
 *
 * @param list of numbers
 *
 * @remarks
 * Return a positive modulo
 */

function sum(values) {
  return values.reduce(function (acc, b) {
    return acc + b;
  }, 0);
}
/**
 * Get mean of all elements in a list
 *
 * @param list of numbers
 */

function mean(values) {
  if (values.length <= 0) {
    return 0;
  }

  return sum(values) / values.length;
}
/**
 * Get median of all elements in a list
 *
 * @param list of numbers
 */

function median(values) {
  if (values.length <= 0) {
    return undefined;
  }

  var sortedValues = toConsumableArray(values).sort();

  var centerIndex = Math.floor(sortedValues.length / 2);
  return sortedValues.length % 2 ? sortedValues[centerIndex] : (sortedValues[centerIndex - 1] + sortedValues[centerIndex]) / 2.0;
} // min, max, output

/**
 * Get the bucket for a given number
 *
 * @param value
 * @param buckets
 */
function bucket(value, buckets) {
  var currentBucket = buckets.find(function (_ref) {
    var _ref2 = slicedToArray(_ref, 2),
        min = _ref2[0],
        max = _ref2[1];

    return value >= min && value < max;
  });
  return currentBucket && currentBucket[2];
}
/**
 * Get number bounded on two sides
 *
 * @param value
 * @param a upper or lower bound
 * @param b upper or lower bound
 */

function bound(value, a, b) {
  var min = Math.min(a, b);
  var max = Math.max(a, b);
  return Math.max(min, Math.min(max, value));
}
/**
 * Get normalized value for a number
 *
 * @param value
 * @param max max value
 * @param min min value
 */

function normalize(value, max, min) {
  return (value - min) / (max - min);
}
/**
 * Get list of numbers from `start` to `end`
 *
 * @param start number from where list starts
 * @param end number where list ends
 */

function getNumbers(start, end) {
  var list = [];

  for (var i = start; i < end; i += 1) {
    list.push(i);
  }

  return list;
}

/**
 * Get trigrams from a sentence
 * @param sentence
 */

function getTrigrams(sentence) {
  var newWord = sentence.trim().toLowerCase().replace(/[^a-zA-Z0-9]/g, ' ').replace(/\s+/g, '  ');
  var formattedWord = "  ".concat(newWord, " ");
  var trigrams = [];

  for (var i = 0; i < formattedWord.length - 2; i += 1) {
    var trigram = formattedWord.substr(i, 3);

    if (trigram[1] !== ' ' || trigram[2] !== ' ') {
      trigrams.push(trigram);
    }
  }

  return new Set(trigrams);
}
/**
 * Get trigram similarity between two sentences
 * @param foo first string
 * @param bar second string
 */

function getTrigramSimilarity(foo, bar) {
  var fooTrigrams = getTrigrams(foo);
  var barTrigrams = getTrigrams(bar);
  var common = intersection(fooTrigrams, barTrigrams);
  var all = union(fooTrigrams, barTrigrams);
  return common.size / all.size;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
});

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

var Ymd = function Ymd(year, month, day) {
  var _this = this;

  classCallCheck(this, Ymd);

  defineProperty(this, "y", void 0);

  defineProperty(this, "m", void 0);

  defineProperty(this, "d", void 0);

  defineProperty(this, "getString", function () {
    return "".concat(padStart(_this.y, 4), "-").concat(padStart(_this.m, 2), "-").concat(padStart(_this.d, 2));
  });

  defineProperty(this, "getYear", function () {
    return _this.y;
  });

  defineProperty(this, "getMonth", function () {
    return _this.m;
  });

  defineProperty(this, "getDay", function () {
    return _this.d;
  });

  defineProperty(this, "isEqual", function (other) {
    return _this.y === other.y && _this.m === other.m && _this.d === other.d;
  });

  defineProperty(this, "isLessThan", function (other) {
    return _this.y < other.y || _this.y === other.y && _this.m < other.m || _this.y === other.y && _this.m === other.m && _this.d < other.d;
  });

  defineProperty(this, "isNotEqual", function (other) {
    return !_this.isEqual(other);
  });

  defineProperty(this, "isGreaterThanOrEqual", function (other) {
    return !_this.isLessThan(other);
  });

  defineProperty(this, "isGreaterThan", function (other) {
    return !_this.isEqual(other) && !_this.isLessThan(other);
  });

  defineProperty(this, "isLessThanOrEqual", function (other) {
    return _this.isEqual(other) || _this.isLessThan(other);
  });

  this.y = year;
  this.m = month;
  this.d = day;
};
var Miti =
/*#__PURE__*/
function (_Ymd) {
  inherits(Miti, _Ymd);

  function Miti(year, month, day, _dict) {
    var _this2;

    classCallCheck(this, Miti);

    _this2 = possibleConstructorReturn(this, getPrototypeOf(Miti).call(this, year, month, day));

    defineProperty(assertThisInitialized(_this2), "dict", void 0);

    defineProperty(assertThisInitialized(_this2), "totalDays", void 0);

    defineProperty(assertThisInitialized(_this2), "getWeek", function () {
      return (_this2.totalDays + 6) % 7 + 1;
    });

    defineProperty(assertThisInitialized(_this2), "getDaysInCurrentMonth", function () {
      return _this2.dict.getDaysInMonth(_this2.getYear(), _this2.getMonth());
    });

    defineProperty(assertThisInitialized(_this2), "getDaysInCurrentYear", function () {
      return _this2.dict.getDaysInYear(_this2.getYear());
    });

    defineProperty(assertThisInitialized(_this2), "getDifference", function (sub) {
      var mitiIsAfterSub = _this2.isGreaterThan(sub);

      var y = mitiIsAfterSub ? _this2.getYear() : sub.getYear();
      var m = mitiIsAfterSub ? _this2.getMonth() : sub.getMonth();
      var d = mitiIsAfterSub ? _this2.getDay() : sub.getDay();
      var y1 = !mitiIsAfterSub ? _this2.getYear() : sub.getYear();
      var m1 = !mitiIsAfterSub ? _this2.getMonth() : sub.getMonth();
      var d1 = !mitiIsAfterSub ? _this2.getDay() : sub.getDay();
      var sign = mitiIsAfterSub ? 1 : -1;
      var no = 0;

      if (y !== y1) {
        // If the years differ
        // Get number of days 'no' till end of year
        no = _this2.dict.getDaysInMonth(y1, m1) - d1 + 1;

        for (var i = m1 + 1; i <= 12; i += 1) {
          no += _this2.dict.getDaysInMonth(y1, i);
        } // Get number of days till the required year


        for (var _i = y1 + 1; _i < y; _i += 1) {
          no += _this2.dict.getDaysInYear(_i);
        } // Get number of days till the required month


        for (var _i2 = 1; _i2 < m; _i2 += 1) {
          no += _this2.dict.getDaysInMonth(y, _i2);
        } // Get number of days till the required date


        no += d;
        no -= 1;
      } else if (m !== m1) {
        // If the months differ
        // Get number of days 'no' till end of month
        no = _this2.dict.getDaysInMonth(y, m1) - d1 + 1; // Get number of days till the required month

        for (var _i3 = m1 + 1; _i3 < m; _i3 += 1) {
          no += _this2.dict.getDaysInMonth(y, _i3);
        } // Get number of days till the required date


        no += d;
        no -= 1;
      } else {
        // Get number of days till the required date
        no = d - d1;
      }

      return sign * no;
    });

    defineProperty(assertThisInitialized(_this2), "addYears", function (no) {
      var y = _this2.getYear() + no;

      var m = _this2.getMonth(); // Fix overflown day


      var d = Math.min(_this2.getDay(), _this2.dict.getDaysInMonth(y, m));
      return new Miti(y, m, d, _this2.dict);
    });

    defineProperty(assertThisInitialized(_this2), "addMonths", function (no) {
      // NOTE: 'no' can be more than 12
      var y = _this2.getYear() + Math.floor((_this2.getMonth() + no - 1) / 12);
      var m = (_this2.getMonth() + no - 1) % 12 + 1; // Fix overflown da)y

      var d = Math.min(_this2.getDay(), _this2.dict.getDaysInMonth(y, m));
      return new Miti(y, m, d, _this2.dict);
    });

    defineProperty(assertThisInitialized(_this2), "addDays", function (no) {
      // return a clone of itself
      if (no === 0) {
        return new Miti(_this2.getYear(), _this2.getMonth(), _this2.getDay(), _this2.dict);
      } // local variables that can be changed


      var y = _this2.getYear();

      var m = _this2.getMonth();

      var d = _this2.getDay(); // Get number of days 'n' till end of current year
      // 1. days remaining in current month


      var n = _this2.dict.getDaysInMonth(y, m) - d + 1; // 2. days remaining in following months

      for (var i = m + 1; i <= 12; i += 1) {
        n += _this2.dict.getDaysInMonth(y, i);
      }

      if (n <= no) {
        // If 'no' exceeds number of days in current year
        // Increment year
        y += 1;

        while (n + _this2.dict.getDaysInYear(y) <= no) {
          n += _this2.dict.getDaysInYear(y);
          y += 1;
        } // Increment month


        m = 1;

        while (n + _this2.dict.getDaysInMonth(y, m) <= no && m < 12) {
          n += _this2.dict.getDaysInMonth(y, m);
          m += 1;
        } // Increment day


        d = 1;
        d += no - n;
      } else {
        // Get number of days 'n' till end of month
        n = _this2.dict.getDaysInMonth(y, m) - d + 1; // If 'no' exceeds number of days in current month

        if (n <= no) {
          // Increment month
          m += 1;

          while (n + _this2.dict.getDaysInMonth(y, m) <= no) {
            n += _this2.dict.getDaysInMonth(y, m);
            m += 1;
          } // Increment day


          d = no - n + 1;
        } else {
          // Get day
          d += no;
        }
      }

      return new Miti(y, m, d, _this2.dict);
    });

    defineProperty(assertThisInitialized(_this2), "subtractDays", function (no) {
      if (no === 0) {
        return new Miti(_this2.getYear(), _this2.getMonth(), _this2.getDay(), _this2.dict);
      }

      var y = _this2.getYear();

      var m = _this2.getMonth();

      var d = _this2.getDay(); // Get number of days 'n' till beginning of year
      // 1. get number of days elapsed in current month


      var n = d; // 2. get number of days elapsed in previous months

      for (var i = m - 1; i >= 1; i -= 1) {
        n += _this2.dict.getDaysInMonth(y, i);
      } // If 'no' exceeds number of days elapsed in current year


      if (n <= no) {
        // Decrement year
        y -= 1;

        while (n + _this2.dict.getDaysInYear(y) <= no) {
          n += _this2.dict.getDaysInYear(y);
          y -= 1;
        } // Decrement month


        m = 12;

        while (n + _this2.dict.getDaysInMonth(y, m) <= no && m > 1) {
          n += _this2.dict.getDaysInMonth(y, m);
          m -= 1;
        } // Decrement date


        d = _this2.dict.getDaysInMonth(y, m) - (no - n);
      } else {
        // Get number of days elapsed in current month
        n = d; // If 'no' exceeds number of days elapsed in current month

        if (n <= no) {
          // Decrement month
          m -= 1;

          while (n + _this2.dict.getDaysInMonth(y, m) <= no) {
            n += _this2.dict.getDaysInMonth(y, m);
            m -= 1;
          } // Decrement date


          d = _this2.dict.getDaysInMonth(y, m) - (no - n);
        } else {
          // Get date
          d -= no;
        }
      }

      return new Miti(y, m, d, _this2.dict);
    });

    defineProperty(assertThisInitialized(_this2), "convertTo", function (dict) {
      var minYmd = dict.getMinYmd();
      var newMiti = new Miti(minYmd.getYear(), minYmd.getMonth(), minYmd.getDay(), dict);
      return newMiti.addDays(_this2.totalDays);
    });

    _this2.dict = _dict;

    var _this2$dict$isValidDa = _this2.dict.isValidDate(assertThisInitialized(_this2)),
        _this2$dict$isValidDa2 = slicedToArray(_this2$dict$isValidDa, 2),
        isValid = _this2$dict$isValidDa2[0],
        errorMessage = _this2$dict$isValidDa2[1];

    if (!isValid) {
      var error = new Error(errorMessage);
      throw error;
    } // NOTE: may not need to calculate this eagerly


    _this2.totalDays = _this2.getDifference(_this2.dict.getMinYmd());
    return _this2;
  } // private getTotalDays = () => this.totalDays


  return Miti;
}(Ymd);
var AD = function () {
  var minDate = new Ymd(1944, 1, 1);
  var maxDate = new Ymd(2034, 4, 12);
  var data = [[365, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], [366, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]];

  var isLeapYear = function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  };

  var getDaysInYear = function getDaysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
  };

  var getDaysInMonth = function getDaysInMonth(year, month) {
    if (month < 1 || month > 12) {
      var error = new Error('Year out of bounds');
      throw error;
    }

    var index = isLeapYear(year) ? 1 : 0;
    return data[index][month];
  };

  var isValidDate = function isValidDate(ymd) {
    if (ymd.getYear() < minDate.getYear() || ymd.getYear() > maxDate.getYear()) {
      return [false, 'Year out of bounds'];
    }

    if (ymd.getMonth() < 0 || ymd.getMonth() > 12) {
      return [false, 'Month out of bounds'];
    }

    if (ymd.getDay() < 0 || ymd.getDay() > getDaysInMonth(ymd.getYear(), ymd.getMonth())) {
      return [false, 'Day out of bounds'];
    } // NOTE: can be inside min/max year but still be out of bounds for conversion


    if (ymd.isGreaterThan(maxDate) || ymd.isLessThan(minDate)) {
      return [false, 'Miti out of bounds'];
    }

    return [true];
  };

  return {
    getMinYmd: function getMinYmd() {
      return minDate;
    },
    getMaxYmd: function getMaxYmd() {
      return maxDate;
    },
    isValidDate: isValidDate,
    isLeapYear: isLeapYear,
    getDaysInYear: getDaysInYear,
    getDaysInMonth: getDaysInMonth
  };
}();
var BS = function () {
  var minDate = new Ymd(2000, 9, 17);
  var maxDate = new Ymd(2090, 12, 30);
  var data = [[365, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], [365, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], [366, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], [365, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], [365, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], [366, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30], [365, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30], [365, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30], [365, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30], [366, 31, 32, 31, 32, 30, 31, 30, 30, 29, 30, 30, 30], [365, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30], [366, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30], [365, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30], [365, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30], [365, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30]];

  var getDaysInYear = function getDaysInYear(year) {
    if (year < minDate.getYear() || year > maxDate.getYear()) {
      var error = new Error('Year out of bounds');
      throw error;
    }

    var index = year - minDate.getYear();
    return data[index][0];
  };

  var getDaysInMonth = function getDaysInMonth(year, month) {
    if (year < minDate.getYear() || year > maxDate.getYear()) {
      var error = new Error('Year out of bounds');
      throw error;
    }

    if (month < 1 || month > 12) {
      var _error = new Error('Month out of bounds');

      throw _error;
    }

    var index = year - minDate.getYear();
    return data[index][month];
  };

  var isLeapYear = function isLeapYear(year) {
    return getDaysInYear(year) === 366;
  };

  var isValidDate = function isValidDate(ymd) {
    if (ymd.getYear() < minDate.getYear() || ymd.getYear() > maxDate.getYear()) {
      return [false, 'Year out of bounds'];
    }

    if (ymd.getMonth() < 0 || ymd.getMonth() > 12) {
      return [false, 'Month out of bounds'];
    }

    if (ymd.getDay() < 0 || ymd.getDay() > getDaysInMonth(ymd.getYear(), ymd.getMonth())) {
      return [false, 'Day out of bounds'];
    } // NOTE: can be inside min/max year but still be out of bounds for conversion


    if (ymd.isGreaterThan(maxDate) || ymd.isLessThan(minDate)) {
      return [false, 'Miti out of bounds'];
    }

    return [true];
  };

  return {
    getMinYmd: function getMinYmd() {
      return minDate;
    },
    getMaxYmd: function getMaxYmd() {
      return maxDate;
    },
    isValidDate: isValidDate,
    isLeapYear: isLeapYear,
    getDaysInYear: getDaysInYear,
    getDaysInMonth: getDaysInMonth
  };
}();

export { AD, BS, Lang, MIN_YEAR, Miti, Ymd, _cs, addSeparator, basicTypes, bound, breakFormat, bucket, camelToKebab, camelToNormal, camelToSnake, capitalize, caseInsensitiveSubmatch, checkVersion, compareBoolean, compareDate, compareLength, compareNumber, compareString, compareStringAsNumber, compareStringByWordCount, compareStringSearch, decodeDate, difference, doesObjectHaveNoData, encodeDate, findDifferenceInList, formatDateToString, formatPdfText, formattedNormalize, getColorOnBgColor, getContrastYIQ, getDate, getDateDifferenceHumanReadable, getDefinedElementAround, getDifferenceInDays, getDuplicates, getElementAround, getErrorForDateValues, getErrorForTimeValues, getFirstKeyByValue, getHashFromString, getHexFromCode, getHexFromRgb, getHexFromRgbRaw, getHexFromString, getLinkedListNode, getNumDaysInMonth, getNumDaysInMonthX, getNumbers, getRandomFromList, getRatingForContentInString, getRgbFromHex, getRgbRawFromHex, getTrigramSimilarity, getTrigrams, interpolateRgb, intersection, isDateValuesComplete, isDefined, isFalsy, isFalsyString, isInteger, isList, isListEqual, isNaN, isNotDefined, isObject, isParamRequired, isTimeValuesComplete, isTruthy, isTruthyString, isValidEmail, isValidHexColor, isValidUrl, listToGroupList, listToMap, mapToList, mapToMap, mean, median, modulo, noOp, normalize, padStart, pick, populateFormat, randomString, removeKey, resolve, reverseRoute, splitInWhitespace, sum, trimWhitespace, typeOf, union, unique };
//# sourceMappingURL=index.es.js.map
